import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  en?: string;
  subtitle?: string;
  linkLabel?: string;
  linkTo?: string;
}

export default function SectionHeading({
  title,
  en,
  subtitle,
  linkLabel,
  linkTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div>
        <div className="flex items-center gap-2">
          <span className="h-4 w-1 rounded-full bg-accent-500 md:h-5" />
          <h2 className="font-heading text-xl font-extrabold tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {en && (
            <span className="hidden font-label text-[10px] uppercase tracking-[0.2em] text-foreground-400 sm:inline">
              {en}
            </span>
          )}
        </div>
        {subtitle && (
          <p className="mt-2 pl-3 text-xs leading-relaxed text-foreground-500 md:text-sm">{subtitle}</p>
        )}
      </div>
      {linkLabel && linkTo && (
        <Link
          to={linkTo}
          className="group flex items-center gap-1 whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-primary-700 md:text-sm"
        >
          {linkLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}